{
  "brand": {
    "tagline": "Your home, remembered."
  },
  "common": {
    "loading": "Loading…",
    "retry": "Try again",
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save changes",
    "optional": "optional",
    "or": "or",
    "you": "you",
    "selected": "selected",
    "skipToContent": "Skip to content",
    "notifications": "Notifications",
    "edit": "Edit",
    "showMore": "Show more",
    "pagination": "Pagination",
    "previous": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{total}}",
    "removedAccount": "Removed account",
    "back": "Back",
    "more": "More actions",
    "filters": "Filters",
    "sort": "Sort",
    "add": "Add",
    "search": "Search",
    "done": "Done",
    "clear": "Clear"
  },
  "nav": {
    "main": "Main navigation",
    "home": "Home",
    "house": "House",
    "profile": "Profile menu",
    "settings": "Settings",
    "signOut": "Sign out",
    "assets": "Equipment",
    "requests": "Requests",
    "account": "Your account"
  },
  "form": {
    "errorSummaryTitle": {
      "one": "There is 1 thing to fix",
      "other": "There are {{count}} things to fix"
    }
  },
  "errors": {
    "generic": "Something went wrong on our side. Try again in a moment.",
    "codes": {
      "network_error": "We could not reach Lumora. Check your connection and try again.",
      "server_error": "Something went wrong on our side. Try again in a moment.",
      "request_failed": "We could not complete that. Try again.",
      "unauthenticated": "Your session ended. Sign in again to continue.",
      "forbidden": "You do not have permission to do this.",
      "not_found": "We could not find what you were looking for.",
      "conflict": "This changed in the meantime. Reload and try again.",
      "version_conflict": "Someone else changed this while you were editing.",
      "csrf_token_mismatch": "Your session expired. Reload the page and try again.",
      "validation_failed": "Some information needs your attention.",
      "too_many_requests": "Too many attempts. Wait {{seconds}} seconds and try again.",
      "invalid_credentials": "The e-mail or password is not right. Check them and try again.",
      "email_not_verified": "Verify your e-mail address first. We sent you a link when you signed up.",
      "email_taken": "That e-mail address is already in use by another account.",
      "already_member": "This person is already a member of the home.",
      "invitation_pending": "There is already a pending invitation for this e-mail.",
      "invitation_expired": "This invitation has expired. Ask for a new one.",
      "invitation_used": "This invitation was already used.",
      "invitation_revoked": "This invitation was cancelled.",
      "invitation_email_mismatch": "This invitation was sent to a different e-mail address.",
      "owner_cannot_be_removed": "The owner cannot be removed. Transfer ownership first.",
      "transfer_pending": "There is already an ownership transfer waiting for an answer.",
      "last_sign_in_method": "This is your only way to sign in. Set a password first, then unlink Google.",
      "verification_token_invalid": "This link has expired or was already used.",
      "password_reset_token_invalid": "This link has expired or was already used. Ask for a new one.",
      "idempotency_key_reused": "This request was already sent with different information.",
      "too_many_requests_nowait": "Too many attempts. Wait a moment and try again.",
      "file_too_large": "The file is too large. Images can be up to 20 MB and PDFs up to 25 MB.",
      "household_storage_quota_exceeded": "This home has run out of file space. Delete files you no longer need and try again.",
      "unsupported_file_type": "This file type is not accepted. Use a photo (JPEG, PNG, WebP, HEIC) or a PDF.",
      "document_not_ready": "The file is still being processed. Try again in a moment.",
      "category_exists": "A category with that name already exists.",
      "extraction_quota_exceeded": "This home has used all document readings for this month. You can fill in the details yourself.",
      "extraction_disabled": "Document reading is not available right now. You can fill in the details yourself.",
      "request_already_selected": "Another quote was already selected for this request. The page shows who was chosen.",
      "request_not_open": "This request is not open for this action.",
      "request_not_editable": "This request can no longer receive new shared information.",
      "request_not_cancellable": "This request can no longer be cancelled.",
      "no_published_revision": "Share the request information first, then invite technicians.",
      "quote_version_not_current": "That quote was updated in the meantime. Review the latest version and choose again.",
      "quote_needs_reconfirmation": "The request information changed. This technician needs to reconfirm the quote before it can be chosen.",
      "quote_expired": "This quote has expired and can no longer be chosen.",
      "quote_withdrawn": "The technician withdrew this quote.",
      "quote_already_selected": "This quote was already selected and can no longer be withdrawn.",
      "revision_outdated": "The request information changed. Review it and send your quote again.",
      "technician_verification_required": "Confirm your e-mail to continue.",
      "technician_verification_required_nohint": "Confirm your e-mail to continue.",
      "invitation_bound_to_other_identity": "This link is already in use by another person.",
      "verification_code_invalid": "That code is not right. Check it and try again.",
      "verification_code_expired": "That code expired. Ask for a new one.",
      "verification_attempts_exceeded": "Too many wrong attempts. Ask for a new code.",
      "internal_error": "Something went wrong on our side. Try again in a moment.",
      "owns_households": "You still own homes. Transfer or delete them first.",
      "export_in_progress": "An export is already being prepared.",
      "export_not_ready": "The export is not ready yet.",
      "export_expired": "This export expired. Request a new one.",
      "reminder_finished": "This reminder is already finished.",
      "service_record_pending": "A record is already waiting for the resident’s confirmation.",
      "technician_not_selected": "Only the chosen provider can register the service.",
      "request_not_selected": "This request has no chosen quote.",
      "service_record_not_correctable": "This record is not waiting for a correction.",
      "service_record_not_pending": "This record is no longer waiting for confirmation."
    },
    "fields": {
      "required": "Fill in this field.",
      "email": "Enter a valid e-mail address.",
      "max": "Use at most {{max}} characters.",
      "min": "Use at least {{min}} characters.",
      "unique": "This value is already in use.",
      "confirmed": "The two values do not match.",
      "invalid": "This value is not valid.",
      "current_password": "The current password is not right.",
      "in": "Choose one of the available options.",
      "timezone": "Choose a valid time zone.",
      "exists": "This item was not found in this home.",
      "date": "Enter a valid date.",
      "integer": "Enter a whole number."
    }
  },
  "states": {
    "error": {
      "title": "We could not load this",
      "description": "Something went wrong on our side. Try again in a moment.",
      "reference": "Reference",
      "reloadPage": "Reload the page"
    },
    "forbidden": {
      "title": "You cannot see this",
      "description": "You do not have access to this page. If you think it is a mistake, ask the home owner."
    },
    "offline": {
      "title": "You are offline",
      "description": "Reconnect to see the latest information. Nothing was saved while you were offline.",
      "banner": "You are offline. Changes cannot be saved until you reconnect."
    },
    "notFound": {
      "title": "Page not found",
      "description": "The link may be wrong, or this page no longer exists.",
      "action": "Go to the start"
    }
  },
  "auth": {
    "fields": {
      "name": "Name",
      "email": "E-mail",
      "password": "Password",
      "newPassword": "New password",
      "passwordConfirmation": "Repeat the password",
      "passwordHint": "Use at least {{min}} characters."
    },
    "google": {
      "continue": "Continue with Google"
    },
    "oauthErrors": {
      "oauth_not_configured": "Google sign-in is not available right now. Use your e-mail and password.",
      "account_exists_link_required": "There is already an account with this e-mail. Sign in with your password, then link Google in Settings.",
      "oauth_failed": "We could not sign you in with Google. Try again or use your e-mail and password."
    },
    "login": {
      "title": "Sign in",
      "description": "Welcome back to Lumora.",
      "submit": "Sign in",
      "remember": "Keep me signed in on this device",
      "forgot": "Forgot your password?",
      "noAccount": "New to Lumora?",
      "createAccount": "Create an account"
    },
    "register": {
      "title": "Create your account",
      "description": "Organize the information of your home in one place.",
      "submit": "Create account",
      "haveAccount": "Already have an account?",
      "signIn": "Sign in",
      "agree": "By creating an account you agree to the Terms of Use and the Privacy Policy (links at the bottom of the page)."
    },
    "forgot": {
      "title": "Reset your password",
      "description": "Enter your e-mail and we will send you a link to choose a new password.",
      "submit": "Send link",
      "sentTitle": "Check your e-mail",
      "sent": "If there is an account with this e-mail, we sent a link to reset the password. It may take a few minutes.",
      "back": "Back to sign in"
    },
    "reset": {
      "title": "Choose a new password",
      "description": "For the account {{email}}.",
      "submit": "Save new password",
      "done": "Password changed. Sign in with your new password.",
      "invalidTitle": "This link is not valid",
      "invalid": "The link has expired, was already used or is incomplete. Ask for a new one.",
      "requestNew": "Ask for a new link"
    }
  },
  "verify": {
    "banner": {
      "badge": "E-mail not verified",
      "text": "Verify {{email}} to invite people to your home. We sent you a link.",
      "resend": "Send the link again",
      "sent": "Link sent. Check your inbox."
    },
    "page": {
      "title": "Verifying your e-mail",
      "checking": "Checking your link…",
      "successTitle": "E-mail verified",
      "success": "Thank you. Your e-mail address is verified.",
      "failedTitle": "We could not verify your e-mail",
      "missing": "This link is incomplete. Open the link from the e-mail again.",
      "expired": "This link has expired or was already used.",
      "expiredSignedIn": "You can ask for a new link from the banner at the top of the page.",
      "expiredAnonymous": "Sign in to ask for a new link.",
      "continue": "Continue"
    }
  },
  "household": {
    "switcher": {
      "label": "Switch home",
      "choose": "Choose a home"
    },
    "onboarding": {
      "title": "Create your first home",
      "description": "A home is where you keep what belongs to it and share it with the people who live there.",
      "action": "Create a home"
    },
    "new": {
      "title": "New home",
      "menu": "Create a new home",
      "description": "Only the name is needed. You can complete the rest later.",
      "submit": "Create home",
      "created": "{{name}} was created."
    },
    "fields": {
      "name": "Name of the home",
      "country": "Country",
      "countryNone": "Not informed",
      "currency": "Currency",
      "currencyHint": "Used as the default for amounts in this home.",
      "timezone": "Time zone",
      "address": "Address",
      "addressHint": "Fill in only what makes sense where you live.",
      "line1": "Address line 1",
      "line2": "Address line 2",
      "neighborhood": "Neighborhood or district",
      "city": "City",
      "region": "State, province or region",
      "postalCode": "Postal code"
    }
  },
  "home": {
    "subtitle": "What needs you in this home.",
    "empty": {
      "title": "Nothing needs you right now",
      "description": "Start by adding an item or asking for a quote.",
      "addAsset": "Add equipment",
      "askQuote": "Request a quote"
    },
    "pending": {
      "title": "Pending",
      "needsAction": "Needs your action",
      "needsAnswer": "Waiting for your answer",
      "waiting": "In progress"
    },
    "verify": {
      "title": "Verify your e-mail",
      "description": "We sent a link to {{email}}. Verifying it lets you invite people to your home."
    },
    "transfer": {
      "title": "{{name}} wants to make you the owner of {{household}}",
      "consequence": "If you accept, you become the only owner and the current owner becomes a member.",
      "expires": "Answer until {{date}}.",
      "accept": "Accept",
      "decline": "Decline",
      "accepted": "You are now the owner.",
      "declined": "Request declined.",
      "confirmTitle": "Become the owner of {{household}}?",
      "confirmDescription": "You will manage members and ownership. {{name}} stays in the home as a member."
    },
    "invitations": {
      "title": {
        "one": "1 invitation waiting for an answer",
        "other": "{{count}} invitations waiting for an answer"
      },
      "description": "The people invited have not joined yet. You can cancel an invitation at any time.",
      "action": "See invitations"
    },
    "outgoing": {
      "title": "Waiting for {{name}} to accept the ownership transfer",
      "action": "See transfer"
    },
    "quotes": {
      "description_one": "{{count}} quote to compare.",
      "description_other": "{{count}} quotes to compare.",
      "action": "See quotes"
    },
    "requests": {
      "draft": "Draft: not shared with a technician yet.",
      "open": "Waiting for technicians to answer.",
      "action": "Open request"
    },
    "service": {
      "title": "Service on {{asset}} is waiting for your confirmation",
      "noAsset": "an item",
      "by": "Reported by {{name}}",
      "action": "Review service"
    },
    "reminders": {
      "title": "Reminders",
      "all": "See all reminders",
      "none": "No upcoming reminders. See or create reminders"
    },
    "activity": {
      "title": "Recent activity",
      "unnamed": "a removed item",
      "generic": "Something happened in the home.",
      "asset_created": "Equipment added: {{subject}}",
      "asset_archived": "Equipment archived: {{subject}}",
      "maintenance_created": "Service recorded on {{subject}}",
      "maintenance_updated": "Service record corrected on {{subject}}",
      "service_record_proposed": "The provider reported a service on {{subject}}",
      "service_record_corrected": "The provider corrected the service on {{subject}}",
      "service_record_correction_requested": "Correction requested from the provider on {{subject}}",
      "service_record_confirmed": "Service confirmed on {{subject}}",
      "request_created": "Request created: {{subject}}",
      "request_quote_selected": "Quote chosen on request {{subject}}",
      "request_cancelled": "Request cancelled: {{subject}}",
      "request_completed": "Request completed: {{subject}}",
      "quote_submitted": "Quote received on request {{subject}}",
      "quote_resubmitted": "Quote updated on request {{subject}}",
      "reminder_completed": "Reminder marked as done: {{subject}}",
      "invitation_accepted": "A new member joined the home"
    },
    "greeting": "Hi, {{name}}"
  },
  "house": {
    "title": "House",
    "roles": {
      "owner": "Owner",
      "member": "Member"
    },
    "settings": {
      "title": "Home details",
      "descriptionOwner": "You can change these details because you are the owner.",
      "descriptionMember": "Only the owner can change these details.",
      "saved": "Changes saved.",
      "conflictTitle": "Someone changed this home while you were editing",
      "conflictDescription": "Your changes are still here and were not saved. Load the latest version, or keep your changes and save them over it.",
      "conflictReload": "Load the latest version",
      "conflictKeep": "Keep my changes and save"
    },
    "members": {
      "title": "Members",
      "descriptionOwner": "People who have access to this home. Removing someone ends their access immediately.",
      "descriptionMember": "People who have access to this home.",
      "joined": "Joined on {{date}}",
      "remove": "Remove",
      "removeTitle": "Remove {{name}}?",
      "removeDescription": "{{name}} loses access to this home immediately. You can invite them again later.",
      "removeConfirm": "Remove access",
      "removed": "{{name}} was removed."
    },
    "invite": {
      "title": "Invite someone",
      "description": "We send an invitation by e-mail. It works once and expires in 7 days.",
      "hint": "The person must use this same e-mail address to join.",
      "submit": "Send invitation",
      "sent": "Invitation sent to {{email}}.",
      "pendingTitle": "Invitations waiting for an answer",
      "none": "No pending invitations.",
      "expires": "Expires on {{date}}",
      "status": {
        "pending": "Waiting"
      },
      "revoke": "Cancel invitation",
      "revokeTitle": "Cancel this invitation?",
      "revokeDescription": "The link sent to {{email}} stops working right away.",
      "revokeConfirm": "Cancel invitation",
      "revoked": "Invitation cancelled."
    },
    "ownership": {
      "title": "Ownership",
      "description": "Transfer the ownership of this home to another member. Nothing changes until they accept.",
      "start": "Transfer ownership",
      "sheetTitle": "Transfer ownership",
      "consequence": "If the member accepts, they become the only owner and you become a member. You keep access, but can no longer manage members or ownership.",
      "chooseMember": "New owner",
      "send": "Send request",
      "started": "Request sent. Nothing changes until it is accepted.",
      "waiting": "Waiting for an answer",
      "pending": "{{name}} has until {{date}} to accept the transfer.",
      "cancel": "Cancel request",
      "cancelled": "Request cancelled.",
      "noCandidates": "To transfer ownership, first invite another person and wait for them to join."
    },
    "leave": {
      "title": "Leave this home",
      "description": "If you leave {{name}}, you lose access to it.",
      "action": "Leave home",
      "confirmTitle": "Leave {{name}}?",
      "confirmDescription": "Your access ends immediately. To come back, the owner needs to invite you again.",
      "confirm": "Leave home",
      "done": "You left {{name}}."
    },
    "documents": {
      "title": "Documents",
      "description": "The home’s invoices, manuals and warranties.",
      "open": "Open documents"
    },
    "delete": {
      "zone": "Danger zone",
      "description": "Deleting the home ends everyone’s access immediately. Export first if you want to keep the data.",
      "open": "Delete this home",
      "confirmTitle": "Delete {{name}}?",
      "consequences": "This cannot be undone.",
      "points": {
        "access": "Everyone loses access right now: members and technicians with links, without exception.",
        "purge": "Data and files are permanently erased within 30 days.",
        "backups": "Backups expire according to their retention and are never restored with access.",
        "export": "If you need the data, export it first."
      },
      "typeName": "Type the home name to confirm: {{name}}",
      "password": "Your password",
      "action": "Delete home",
      "done": "The home was deleted."
    },
    "export": {
      "cardTitle": "Export data",
      "cardDescription": "Download a copy of the home’s data and files.",
      "open": "Export",
      "crumb": "Export",
      "title": "Export the home’s data",
      "intro": "Create a copy to keep or take with you. Only the owner can export.",
      "includedTitle": "What is included",
      "included": "Equipment, services, requests, quotes, reminders and members as JSON and CSV, plus the ready files, in one ZIP.",
      "excludedTitle": "What is not included",
      "excluded": "Passwords, tokens, secrets and other homes’ data are never exported.",
      "availability": "The export is available for download for 24 hours and then deleted.",
      "requestTitle": "Your export",
      "none": "You have not requested an export yet.",
      "request": "Request export",
      "again": "Request a new export",
      "inProgress": "An export is already being prepared. Follow it here.",
      "ownerOnly": "Only the owner of the home can export the data.",
      "status": {
        "queued": "Queued",
        "processing": "Preparing",
        "ready": "Ready to download",
        "failed": "Did not work",
        "expired": "Expired"
      },
      "requestedAt": "Requested on {{date}}",
      "preparing": "We are preparing the file. This page updates by itself.",
      "expiresAt": "Available until {{date}}",
      "download": "Download ZIP",
      "failedNote": "The export failed. You can request it again.",
      "expiredNote": "The 24-hour window ended and the file was deleted. Request a new one."
    }
  },
  "invite": {
    "title": "You were invited to a home",
    "description": "{{inviter}} invited you to join {{household}} on Lumora.",
    "household": "Home",
    "invitedBy": "Invited by",
    "forAddress": "Sent to",
    "expires": "Valid until",
    "signedInAs": "You are signed in as {{email}}.",
    "signInPrompt": "Sign in or create an account with the invited e-mail address to accept.",
    "signIn": "Sign in",
    "createAccount": "Create an account",
    "accept": "Accept invitation",
    "joined": "You joined {{name}}.",
    "useOtherAccount": "Sign out and use another account",
    "goHome": "Go to the start",
    "unavailableTitle": "This invitation is not available",
    "errors": {
      "invitation_not_found": "We could not find this invitation. Check the link in your e-mail.",
      "invitation_expired": "This invitation has expired. Ask the owner of the home for a new one.",
      "invitation_used": "This invitation was already used.",
      "invitation_revoked": "The owner cancelled this invitation.",
      "invitation_email_mismatch": "This invitation was sent to {{hint}}, but you are signed in as {{email}}. Sign out and use the invited address.",
      "already_member": "You are already a member of this home."
    }
  },
  "settings": {
    "title": "Settings",
    "saved": "Saved.",
    "notSynced": "Your choice applies on this device, but we could not save it to your profile.",
    "profile": {
      "title": "Profile"
    },
    "email": {
      "title": "E-mail",
      "verified": "Verified",
      "unverified": "Not verified",
      "pending": "Waiting for you to confirm {{email}}. Your e-mail does not change until you open the link we sent there.",
      "description": "Changing the e-mail needs your current password. We send a link to the new address.",
      "newEmail": "New e-mail",
      "submit": "Change e-mail",
      "sent": "We sent a link to {{email}}. Your e-mail changes after you confirm it.",
      "needPassword": "Set a password below to be able to change your e-mail."
    },
    "appearance": {
      "title": "Language and appearance"
    },
    "language": {
      "label": "Language"
    },
    "theme": {
      "label": "Theme",
      "light": "Light",
      "dark": "Dark",
      "system": "Same as device"
    },
    "password": {
      "title": "Password",
      "description": "Changing the password ends your other sessions.",
      "setTitle": "Set a password",
      "setDescription": "Your account has no password yet. Setting one lets you also sign in with e-mail.",
      "current": "Current password",
      "submit": "Change password",
      "setSubmit": "Set password",
      "changed": "Password saved."
    },
    "oauth": {
      "title": "Ways to sign in",
      "description": "You can keep your Google account linked to sign in faster.",
      "link": "Link Google account",
      "linked": "Google linked",
      "unlink": "Unlink Google",
      "unlinkTitle": "Unlink Google?",
      "unlinkDescription": "You will no longer be able to sign in with Google. Make sure you can still sign in with another method.",
      "unlinked": "Google unlinked.",
      "notice": {
        "signed_in": "You signed in with Google.",
        "linked": "Your Google account is linked."
      }
    },
    "session": {
      "title": "Session"
    },
    "confirmEmail": {
      "title": "Confirming your new e-mail",
      "successTitle": "E-mail changed",
      "success": "Your e-mail is now {{email}}.",
      "failedTitle": "We could not change your e-mail",
      "back": "Back to settings"
    },
    "delete": {
      "title": "Delete account",
      "description": "Closes your account and removes you from homes. Homes you own must be transferred or deleted first.",
      "open": "Delete my account",
      "confirmTitle": "Delete your account?",
      "consequences": "You leave every home and lose access. Your name is removed from the history other members keep: it shows as “Removed account”. This cannot be undone.",
      "password": "Your password",
      "typeEmail": "Type your e-mail to confirm: {{email}}",
      "action": "Delete account",
      "ownsTitle": "You still own homes",
      "ownsBody": "Transfer ownership or delete these homes, then try again:",
      "ownsUnnamed": "Open home",
      "goodbyeTitle": "Your account was deleted",
      "goodbyeBody": "Thank you for using Lumora. Your personal data was removed and you left every home.",
      "goodbyeAction": "Go to sign in"
    },
    "legal": {
      "title": "About",
      "privacy": "Privacy Policy",
      "terms": "Terms of Use"
    }
  },
  "catalog": {
    "title": "Component catalog",
    "width": "Frame width",
    "syntheticNote": "Synthetic examples only. No real data.",
    "sections": {
      "buttons": "Buttons",
      "fields": "Fields",
      "status": "Status",
      "overlays": "Dialogs and menus",
      "layout": "Layout",
      "states": "Page states",
      "assets": "Home items",
      "history": "Service history",
      "extraction": "Reading review",
      "upload": "File upload",
      "warranty": "Warranty",
      "requests": "Share and quotes",
      "technician": "Technician",
      "m4": "Reminders, notices and confirmations",
      "mobile": "Mobile app patterns"
    }
  },
  "money": {
    "hint": "Type it as usual. Example: {{example}}",
    "currency": "Currency",
    "errors": {
      "invalid": "We could not read this amount. Use only numbers, with your language’s separator for decimals.",
      "too_many_decimals": "This currency accepts fewer decimal places. Fix the amount; we never round for you.",
      "too_large": "This amount is too large.",
      "negative": "The amount cannot be negative."
    }
  },
  "warranty": {
    "valid": "Warranty valid",
    "expiring_one": "Warranty ends in {{count}} day",
    "expiring_other": "Warranty ends in {{count}} days",
    "endsToday": "Warranty ends today",
    "expired": "Warranty expired",
    "notInformed": "Warranty not provided"
  },
  "history": {
    "by": {
      "you": "Recorded by you",
      "name": "Recorded by {{name}}",
      "resident": "Recorded by a resident",
      "technician": "Reported by the provider",
      "removed": "Recorded by a removed account"
    },
    "edited": "Edited",
    "status": {
      "pending_confirmation": "Waiting for confirmation",
      "correction_requested": "Correction requested",
      "confirmed": "Confirmed by the resident"
    },
    "receipts": "Receipts",
    "recordedAt": "Recorded on {{date}}",
    "details": "See details"
  },
  "assets": {
    "title": "Equipment and areas",
    "subtitle": "Everything you want to remember about your home, in one place.",
    "add": "Add equipment",
    "fromPhoto": "Add from a photo or receipt",
    "fromPhotoCrumb": "From a photo or receipt",
    "archivedBadge": "Archived",
    "kind": {
      "equipment": "Equipment",
      "area": "Area"
    },
    "kindHelp": {
      "equipment": "A device or item, like a fridge or a pump.",
      "area": "A part of the home, like the roof or the garden."
    },
    "count_one": "{{formatted}} item",
    "count_other": "{{formatted}} items",
    "search": {
      "label": "Search",
      "placeholder": "Name, brand, model or room"
    },
    "sort": {
      "label": "Sort by",
      "name": "Name (A–Z)",
      "-name": "Name (Z–A)",
      "-updated_at": "Recently updated",
      "updated_at": "Least recently updated"
    },
    "filters": {
      "title": "Filters",
      "kind": "Type",
      "kindAll": "Equipment and areas",
      "category": "Category",
      "categoryAll": "All categories",
      "room": "Room",
      "roomAll": "All rooms",
      "archived": "Show archived only",
      "all": "All",
      "equipment": "Equipment",
      "areas": "Areas"
    },
    "empty": {
      "title": "Nothing here yet",
      "description": "Add a piece of equipment to keep its brand, model, warranty, photos and services in one place. A name is enough to start."
    },
    "noResults": {
      "title": "No results",
      "description": "Nothing matches this search or these filters.",
      "clear": "Clear search and filters"
    },
    "categories": {
      "refrigerator": "Refrigerator or freezer",
      "washer": "Washing machine",
      "dryer": "Dryer or washer-dryer",
      "dishwasher": "Dishwasher",
      "cooking": "Stove, cooktop or oven",
      "microwave": "Microwave",
      "hvac": "Heating, cooling and ventilation",
      "electronics": "TV, audio and electronics",
      "water_heater": "Water heaters",
      "filters": "Filters and purifiers",
      "pumps": "Pumps",
      "garden_pool": "Garden and pool",
      "small_appliances": "Small appliances",
      "electrical": "Electrical",
      "plumbing": "Plumbing",
      "roof": "Roof",
      "other": "Other"
    },
    "fields": {
      "name": "Name",
      "category": "Category",
      "categoryNone": "No category",
      "categoryNew": "Create a new category…",
      "categoryName": "New category name",
      "categoryCreate": "Create category",
      "room": "Room",
      "roomHint": "Write anything, for example “Kitchen”. We suggest the ones you already used.",
      "brand": "Brand",
      "model": "Model",
      "serial": "Serial number",
      "purchaseDate": "Purchase date",
      "price": "Price paid",
      "seller": "Seller or store",
      "warrantyUntil": "Warranty ends on",
      "warrantyHint": "Fill in only if you know it. We never work out the warranty for you.",
      "warrantyReminder": "Remind me 30 days before it ends",
      "notes": "Notes"
    },
    "form": {
      "newTitle": "New equipment or area",
      "editTitle": "Edit",
      "newCrumb": "New",
      "editCrumb": "Edit",
      "newIntro": "Only the name is required. You can fill in the rest whenever you like.",
      "fromPhotoLink": "Prefer to start from a label photo or a receipt?",
      "identification": "Identification",
      "kind": "What is it?",
      "product": "Product",
      "purchase": "Purchase and warranty",
      "notes": "Notes",
      "photo": "Photo",
      "photoHint": "Helps you recognise the item. Not required.",
      "photoUploadHint": "Upload a photo of the equipment or area.",
      "removePhoto": "Remove photo",
      "attachedFile": "File that will be kept with the item: {{name}}",
      "useAsCover": "Use this photo as the equipment photo",
      "waitUpload": "Wait for the file to finish before saving.",
      "create": "Create",
      "created": "Equipment created.",
      "createdNoFile": "Created, but we could not attach the file. Upload it again on the item page.",
      "saved": "Changes saved.",
      "conflictTitle": "Someone changed this while you were editing",
      "conflictDescription": "Your changes are still here and have not been saved. Load the latest version, or keep your changes and save over it.",
      "conflictReload": "Load the latest version",
      "conflictKeep": "Keep my changes and save"
    },
    "detail": {
      "history": "Service history",
      "historyEmpty": {
        "title": "No services recorded",
        "description": "Record maintenance and repairs so you can later tell what was done, when and by whom."
      },
      "documents": "Documents",
      "documentsEmpty": "No documents linked to this item.",
      "addDocument": "Upload another document",
      "unlink": "Unlink",
      "unlinkTitle": "Unlink this document?",
      "unlinkDescription": "It stops showing on this item but stays in the home’s documents.",
      "identification": "Identification",
      "identificationEmpty": "No brand, model or serial number yet. You can add them whenever you like.",
      "warranty": "Warranty",
      "warrantyUntil": "Until {{date}}, as you provided",
      "warrantyNote": "We only show the warranty you provide.",
      "notes": "Notes",
      "enlarge": "Enlarge photo",
      "enlargeShort": "Enlarge",
      "photoAlt": "Photo of {{name}}",
      "copy": "Copy",
      "copiedShort": "Copied",
      "copySerial": "Copy serial number",
      "copied": "Serial number copied.",
      "copyFailed": "Could not copy. Select the text and copy it yourself.",
      "readDocument": "Read a label or receipt",
      "archivedNote": "This item is archived. Its history and documents are kept.",
      "archiveTitle": "Archive",
      "archiveDescription": "Archiving removes the item from the main list. Its service history and documents are preserved and you can restore it later.",
      "archive": "Archive",
      "archived": "Item archived.",
      "archiveConfirmTitle": "Archive “{{name}}”?",
      "archiveConfirmDescription": "The item leaves the main list, but its service history and documents stay saved. You can restore it whenever you like.",
      "restoreTitle": "Restore",
      "restoreDescription": "Brings the item back to the main list.",
      "restore": "Restore",
      "restored": "Item restored.",
      "reminders": "Reminders",
      "remindersAll": "See all",
      "remindersNew": "New reminder",
      "remindersEmpty": "No active reminders for this item.",
      "addPhoto": "Add photo",
      "changePhoto": "Change photo",
      "photoSaved": "Item photo updated"
    }
  },
  "services": {
    "register": "Record a service",
    "intro": "Note what was done, even if you did not ask for a quote here.",
    "editTitle": "Correct record",
    "editIntro": "When you save, we keep the previous version. The record will show as edited.",
    "detailCrumb": "Service",
    "save": "Save service",
    "saved": "Service recorded.",
    "updated": "Record corrected.",
    "conflict": "Someone else changed this record. Your changes are still here and have not been saved.",
    "readOnlyTechnician": "This record was reported by the provider and cannot be edited here.",
    "fields": {
      "asset": "Equipment or area",
      "assetChoose": "Choose an item",
      "date": "Service date",
      "description": "What was done",
      "descriptionHint": "For example: filter replaced and general cleaning.",
      "provider": "Provider",
      "parts": "Parts",
      "cost": "Amount paid",
      "warrantyUntil": "Service warranty until",
      "warrantyHint": "Fill in only if the provider gave a warranty.",
      "warrantyNotes": "Warranty terms"
    },
    "documents": {
      "title": "Receipts",
      "hint": "Attach invoices, receipts or photos. Up to {{max}} files.",
      "pick": "Choose from the home’s documents",
      "remove": "Remove {{name}}",
      "full": "Limit of {{max}} files reached.",
      "none": "No receipts attached."
    },
    "pick": {
      "title": "Home documents",
      "description": "Tick the ones to attach. {{count}} more fit.",
      "none": "There are no other ready documents to attach.",
      "add_one": "Attach {{count}} document",
      "add_other": "Attach {{count}} documents"
    },
    "revisions": {
      "title": "Corrections",
      "description": "Each edit keeps the previous version so you can see what changed.",
      "show_one": "See the previous version",
      "show_other": "See the {{count}} previous versions",
      "entry": "Version {{version}} · replaced on {{when}} by {{name}}",
      "previous": "Previous values",
      "unknown": "someone in the home"
    },
    "review": {
      "title": "Service reported by the provider",
      "confirm": "Confirm service",
      "askCorrection": "Ask for a correction",
      "confirmTitle": "Confirm this service?",
      "confirmBody": "Once confirmed, the service goes into the item’s history and the request is completed.",
      "notCertification": "The confirmation is yours, the resident’s: it is not an independent technical certification of the work.",
      "confirmAction": "Confirm service",
      "confirmed": "Service confirmed. The request is completed.",
      "correctionTitle": "Ask the provider for a correction",
      "correctionBody": "The provider will see the reason and can resend the record.",
      "reason": "What needs to be corrected?",
      "correctionAction": "Send correction request",
      "correctionSent": "Correction request sent.",
      "waitingCorrection": "Waiting for the provider’s correction",
      "yourReason": "Reason given: {{reason}}",
      "stale": "This record changed while you were looking. We refreshed the screen: check it and try again.",
      "noneYet": "The provider has not reported the work done yet.",
      "completedTitle": "Request completed",
      "completedBody": "You confirmed the service and it is in the item’s history.",
      "seeHistory": "See the item’s history",
      "confirmedBy": "Confirmed by the resident {{name}} on {{date}}."
    }
  },
  "documents": {
    "kinds": {
      "photo": "Photo",
      "label": "Label photo",
      "invoice": "Invoice",
      "receipt": "Receipt",
      "manual": "Manual",
      "warranty": "Warranty document",
      "other": "Other"
    },
    "status": {
      "ready": "Ready",
      "processing": "Processing",
      "rejected": "Rejected"
    },
    "notReadyYet": "Uploaded, but not ready yet. You can open it once processing finishes.",
    "rejection": {
      "unsupported_file_type": "The file content is not an accepted type. Use a photo (JPEG, PNG, WebP, HEIC) or a PDF.",
      "file_too_large": "The file is too large.",
      "corrupted_file": "We could not open the file. It may be damaged.",
      "encrypted_pdf": "This PDF is password-protected. Upload a version without a password.",
      "too_many_pages": "This PDF has too many pages. Upload only the pages you need.",
      "processing_failed": "We could not process the file. Try uploading it again."
    },
    "pages_one": "{{count}} page",
    "pages_other": "{{count}} pages",
    "uploadedBy": "uploaded by {{name}}",
    "open": "Open",
    "opensInNewTab": "(opens in a new tab)",
    "download": "Download",
    "added": "Document added.",
    "untitled": "Untitled document",
    "upload": {
      "choose": "Choose a file",
      "chooseAnother": "Choose another file",
      "camera": "Take a photo",
      "hint": "Photo (JPEG, PNG, WebP, HEIC) or PDF. Up to 20 MB for images and 25 MB for PDFs.",
      "kindLabel": "Document type",
      "uploading": "Uploading file",
      "uploadingProgress": "Uploading… {{percent}}%",
      "processing": "Processing the file…",
      "processingExplain": "The file was uploaded, but it can only be used once it is ready.",
      "processingSlow": "This is taking longer than usual. You can keep waiting or come back later; the file keeps being processed.",
      "another": "Upload another file",
      "rejectedTitle": "This file could not be used",
      "errorTitle": "Could not upload",
      "sensitiveNote": "Labels, invoices and receipts can show a serial number, a name or an address. The file stays private in your home and you can remove it any time.",
      "client": {
        "unsupported_file_type": "This file type is not accepted. Use a photo (JPEG, PNG, WebP, HEIC) or a PDF.",
        "file_too_large": "The file is too large. Images can be up to 20 MB and PDFs up to 25 MB.",
        "empty_file": "The file is empty."
      }
    },
    "library": {
      "title": "Home documents",
      "subtitle": "Invoices, manuals, warranties and photos, kept private.",
      "add": "Add a document",
      "search": "Search by name",
      "allKinds": "All types",
      "asset": "Equipment or area",
      "allAssets": "All",
      "selectedAsset": "Selected item",
      "sortNewest": "Newest first",
      "sortOldest": "Oldest first",
      "sortTitle": "Name (A–Z)",
      "noResults": "No documents found",
      "emptyTitle": "No documents yet",
      "emptyDescription": "Keep invoices, manuals and warranties here so you can find them when you need them.",
      "count_one": "{{formatted}} document",
      "count_other": "{{formatted}} documents"
    },
    "edit": {
      "action": "Rename or reclassify",
      "title": "Rename or reclassify",
      "description": "Only the name and type change; the file itself is untouched.",
      "name": "Name",
      "originalName": "Original file: {{name}}",
      "saved": "Document updated.",
      "conflict": "Someone else changed this document. Close and reopen to see the latest version."
    },
    "delete": {
      "action": "Delete",
      "title": "Delete this document?",
      "description": "Access to the file ends now, for everyone in the home, and it stops showing on items. The file is removed from storage a little later.",
      "confirm": "Delete document",
      "done": "Document deleted."
    }
  },
  "extraction": {
    "titleCreate": "Add from a photo or receipt",
    "titleUpdate": "Read a label or receipt",
    "introCreate": "Upload a photo of the label, of the item itself, or the receipt. We suggest the details and you decide what to accept.",
    "introUpdate": "Upload or pick a file. Suggestions only change the item if you accept them.",
    "whatIs": "What are you uploading?",
    "task": {
      "label": "Photo of the label",
      "receipt": "Invoice or receipt",
      "item": "Photo of the item"
    },
    "taskHelp": {
      "label": "The label with brand, model and serial number.",
      "receipt": "Shows the store, date and price of the purchase.",
      "item": "No label, or out of reach? We try to recognise what it is and the brand, if visible."
    },
    "nameOptional": "Equipment name",
    "nameOptionalHint": "If you already know it. We keep it in case reading does not work.",
    "uploadHint": "Photo (JPEG, PNG, WebP, HEIC) or PDF.",
    "useExisting": "Or use a file already on this item",
    "useThis": "Use this one",
    "manualInstead": "I would rather fill it in myself",
    "backToAsset": "Back to the item",
    "consentTitle": "Before reading the document",
    "consent": "Only this file will be sent to {{provider}} to be read.",
    "consentFine": "No other information about your home is sent. Nothing changes without your acceptance.",
    "quota": "You have used {{used}} of {{limit}} readings this month.",
    "allow": "Allow and read the document",
    "fillManually": "Fill in manually",
    "quotaReachedTitle": "This month’s readings are used up",
    "quotaReached": "This home has used all {{limit}} readings for this month.",
    "disabledTitle": "Reading unavailable",
    "disabled": "Document reading is switched off at the moment.",
    "manualStillWorks": "The file is saved and manual entry still works.",
    "reading": "Reading the document…",
    "readingHint": "This can take a few seconds.",
    "failedTitle": "We could not read the document",
    "failedKept": "The file is saved. You can carry on filling in the details yourself.",
    "errors": {
      "provider_unavailable": "The reading service is unavailable right now.",
      "provider_timeout": "Reading took too long and was stopped.",
      "invalid_provider_output": "We could not make sense of the reading result.",
      "unsupported_document": "This kind of document cannot be read.",
      "document_too_large": "The document is too large to be read.",
      "timeout": "Reading is taking longer than usual.",
      "generic": "We could not read the document right now."
    },
    "review": {
      "intro": "These are suggestions. Nothing is applied until you accept it, field by field, and you can edit first.",
      "current": "Current value",
      "empty": "Empty",
      "suggestion": "Suggestion",
      "accept": "Use this value",
      "accepted": "Value accepted",
      "nameHint": "Required. Pick a suggestion or write your own.",
      "nameSuggestions": "Name suggestions:",
      "read": "Read in the document: {{value}}",
      "readRaw": "Read in the document: {{amount}} {{currency}}. Confirm the amount below."
    },
    "notFound": {
      "name": "We did not identify a name. You can fill it in now or later.",
      "category": "We did not identify the category. You can choose it now or later.",
      "brand": "We did not identify the brand. You can fill it in now or later.",
      "model": "We did not identify the model. You can fill it in now or later.",
      "serial_number": "We did not identify the serial number. You can fill it in now or later.",
      "seller": "We did not identify the store. You can fill it in now or later.",
      "purchase_date": "We did not identify the purchase date. You can fill it in now or later.",
      "price": "We did not identify the price. You can fill it in now or later."
    },
    "createWith": "Create equipment with what I accepted",
    "applyAccepted": "Apply what I accepted",
    "updated": "Item updated.",
    "conflict": "Someone else changed this item. Reload the current data and confirm again.",
    "conflictReload": "Reload current data"
  },
  "requests": {
    "title": "Requests",
    "subtitle": "Ask technicians for quotes and compare their answers.",
    "ask": "Request a quote",
    "noItem": "No item linked",
    "unpublished": "There are changes not shared yet",
    "unpublishedShort": "Not shared yet",
    "updatedAt": "Updated {{date}}",
    "count_one": "{{formatted}} request",
    "count_other": "{{formatted}} requests",
    "counts": {
      "invitations_one": "{{count}} technician invited",
      "invitations_other": "{{count}} technicians invited",
      "quotes_one": "{{count}} quote",
      "quotes_other": "{{count}} quotes"
    },
    "status": {
      "draft": "Draft",
      "open": "Waiting for answers",
      "selected": "Selected",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "filters": {
      "status": "Status",
      "statusAll": "All statuses",
      "asset": "Equipment or area",
      "assetAll": "All items",
      "sort": "Sort by"
    },
    "sort": {
      "-updated_at": "Recently updated",
      "-created_at": "Newest first",
      "created_at": "Oldest first"
    },
    "empty": {
      "title": "No requests yet",
      "description": "Start a request when something needs a technician. You choose what to share, and each technician gets their own link."
    },
    "noResults": {
      "title": "No requests with these filters",
      "description": "Try another status or item.",
      "clear": "Clear filters"
    },
    "fields": {
      "title": "What do you need?",
      "titleHint": "A short title, for example “Refrigerator not cooling”.",
      "description": "Description",
      "symptoms": "What is happening",
      "symptomsHint": "Noises, error codes, when it started.",
      "availability": "When can someone visit?",
      "availabilityHint": "Free text, for example “weekday mornings”. Lumora does not schedule visits.",
      "neighborhood": "Neighborhood",
      "city": "City",
      "locationHint": "Optional. Only shared if you choose to. Your full address is never shared.",
      "currency": "Currency of the quotes",
      "currencyHint": "Technicians quote in this currency.",
      "currencyLocked": "The currency cannot change after the request is shared."
    },
    "new": {
      "title": "New request",
      "intro": "Three short steps: the item, the problem and what the technician will see.",
      "fromIntro": "Review the information copied from the previous request, then choose what to share.",
      "steps": "Steps",
      "step": {
        "item": "Item",
        "problem": "Problem",
        "share": "Share"
      },
      "next": "Continue",
      "nextShare": "Continue to sharing",
      "back": "Back",
      "item": {
        "title": "Which item needs help?",
        "hint": "You can also start without an item and add it later.",
        "mode": {
          "existing": "An item I already registered",
          "new": "Register a new item now",
          "none": "I do not have an item yet"
        },
        "modeHint": {
          "existing": "Pick it from your equipment and areas.",
          "new": "Only a few details are needed.",
          "none": "You can describe the problem without linking an item."
        },
        "pick": "Equipment or area",
        "pickChoose": "Choose…",
        "newHint": "We will register it in your home so it is there next time."
      },
      "problem": {
        "title": "Describe the problem",
        "noItem": "No item linked to this request.",
        "newItem": "A new item will be registered: {{name}}.",
        "withItem": "Item: {{name}}"
      },
      "share": {
        "title": "What the technician will see",
        "intro": "Nothing is shared until you publish. Choose below and check the preview."
      },
      "progress": "Step {{current}} of {{total}} · {{name}}"
    },
    "share": {
      "publish": "Publish and continue",
      "publishUpdate": "Share the updated information",
      "publishTitle": "Choose what to share",
      "updateTitle": "Update shared information",
      "updateIntro": "Choose what the technicians will see in the new version.",
      "updateNote": "Invited technicians will be notified of the update, and quotes already sent will need to be reconfirmed by them before you can choose one.",
      "published": "Request shared (version {{number}}).",
      "sendFailed": "Could not send. Your draft was kept. Try again.",
      "conflict": "This request was changed somewhere else. Reload to see the latest version, then publish again.",
      "reload": "Reload the request",
      "notEditable": "This request no longer accepts new shared information."
    },
    "detail": {
      "fields": "Request details",
      "saved": "Request updated.",
      "editNote": "Changes here stay private until you share them again.",
      "conflict": "Someone changed this request while you were editing. Reload the page to see the latest version.",
      "location": "Neighborhood and city",
      "publish": "Choose what to share and publish",
      "updateShared": "Update shared information",
      "unpublishedTitle": "There are changes not shared yet",
      "unpublishedBody": "Technicians still see the previous version. When you update the shared information, they are notified and their quotes need to be reconfirmed.",
      "nextStep": "Next step: create a link for each technician you want to hear from.",
      "quotes": {
        "title": "Quotes",
        "compare": "Compare quotes",
        "empty": "No quotes yet. Technicians answer from their own link."
      },
      "revisions": {
        "title": "Shared versions",
        "number": "Version {{number}}",
        "current": "Current",
        "view": "See exactly what was shared",
        "item": "Item details",
        "documents_one": "{{count}} document",
        "documents_other": "{{count}} documents",
        "records_one": "{{count}} service record",
        "records_other": "{{count}} service records",
        "location": "neighborhood and city"
      }
    },
    "invitations": {
      "title": "Technicians",
      "intro": "Each technician gets an individual link. You can revoke it at any time.",
      "needsPublish": "Publish the request first to invite technicians.",
      "closed": "This request is not accepting new technicians.",
      "empty": "No technicians invited yet.",
      "unnamed": "Technician without a name",
      "status": {
        "active": "Link active",
        "revoked": "Link revoked",
        "expired": "Link expired"
      },
      "verified": "Identity verified",
      "notVerified": "Not verified yet",
      "quoteYes": "Quote received",
      "quoteNo": "No quote yet",
      "expires": "Link valid until",
      "viewed": "Last viewed",
      "notViewed": "Not viewed yet",
      "identity": "Verified identity",
      "newLink": "Generate a new link",
      "revoke": "Revoke access",
      "revoked": "Access revoked.",
      "revokeTitle": "Revoke access of {{name}}?",
      "revokeDescription": "The technician loses access immediately. Files already downloaded cannot be recovered.",
      "rotateTitle": "Generate a new link for {{name}}?",
      "rotateDescription": "The previous link stops working. Send the new link to the same technician.",
      "create": {
        "open": "Create a link for a technician",
        "title": "New technician link",
        "description": "The link opens only what you chose to share.",
        "label": "Private label",
        "labelHint": "Only you see it, for example “João’s electrician”.",
        "email": "Technician e-mail",
        "emailHint": "If you fill it in, we e-mail the link and only that address can verify.",
        "locale": "Language for the technician",
        "localeHint": "The technician can change it on the page.",
        "days": "Valid for (days)",
        "daysInvalid": "Use a whole number from 1 to 60.",
        "submit": "Create link"
      },
      "link": {
        "title": "Link ready",
        "description": "Send it to the technician yourself, for example by message. Lumora does not send it automatically.",
        "label": "Technician link",
        "copy": "Copy link",
        "copiedShort": "Copied",
        "copied": "Link copied.",
        "copyFailed": "Could not copy. Select the link and copy it manually.",
        "share": "Share",
        "shareTitle": "Request for a quote",
        "shareText": "Here is the information for the quote:",
        "once": "This link is shown only now and cannot be shown again. If you lose it, generate a new link and the old one stops working.",
        "emailed": "We also e-mailed this link to {{email}}.",
        "done": "Done"
      }
    },
    "selection": {
      "quoteSelected": "Quote selected",
      "visitRequested": "Visit requested",
      "requestCancelled": "Request cancelled",
      "quoteTitle": "Quote selected: {{name}}",
      "visitTitle": "Visit requested: {{name}}",
      "on": "Chosen on {{date}}",
      "by": "by {{name}}",
      "quoteNote": "You chose this quote. The final terms are still agreed with the provider.",
      "visitNote": "You asked for an evaluation visit. This is not an acceptance of a final price.",
      "disclaimer": "Choosing is not a contract and not a payment. Final terms and the work itself are agreed directly with the provider.",
      "seeQuote": "See the quote",
      "switchNote": "To work with another technician, cancel this request and create a new one. The history of this choice is kept.",
      "createFromThis": "Create a new request with the same information"
    },
    "cancel": {
      "title": "Cancel request",
      "description": "Technicians are notified and their links stop being useful. The history is kept.",
      "descriptionDraft": "This draft will be cancelled. Nothing was shared with technicians.",
      "descriptionSelected": "A technician was already chosen. Cancelling keeps the history and the choice, notifies the technician and needs a reason.",
      "action": "Cancel request",
      "confirmTitle": "Cancel this request?",
      "confirm": "Technicians will be notified. The history and the quotes received are kept.",
      "confirmSelected": "The chosen technician will be notified. The history, the quotes and the choice are kept.",
      "reason": "Reason",
      "reasonRequired": "Tell us the reason: it is shared with the technician.",
      "reasonLabel": "Reason",
      "keep": "Keep the request",
      "done": "Request cancelled.",
      "cancelledTitle": "This request was cancelled",
      "history": "The history is kept and technicians are notified."
    }
  },
  "share": {
    "privacy": {
      "title": "The technician will see only the information selected below.",
      "body": "Your full address is never shared. Documents are off until you choose them."
    },
    "item": {
      "title": "Item details",
      "hint": "The name and category of “{{name}}” are always shared. Choose the rest.",
      "none": "No item is linked, so no item details are shared.",
      "notInformed": "Not informed",
      "fields": {
        "brand": "Brand",
        "model": "Model",
        "serial_number": "Serial number",
        "room": "Room",
        "purchase_date": "Purchase date",
        "warranty_until": "Warranty end date"
      }
    },
    "location": {
      "title": "Location",
      "include": "Share neighborhood and city",
      "empty": "Fill in neighborhood or city in the problem step to share them.",
      "neverAddress": "Your full address is never shared."
    },
    "documents": {
      "title": "Documents",
      "hint": "Choose up to {{max}} documents the technician can open. Only ready files are listed.",
      "sensitive": "Invoices, manuals and label photos can contain personal details. They are off until you choose them.",
      "sensitiveKind": {
        "label": "Labels may contain sensitive information",
        "invoice": "Invoices may contain personal data",
        "receipt": "Receipts may contain personal data"
      },
      "none": "No ready documents for this item.",
      "full": "You reached the limit of {{max}} documents.",
      "pickMore": "Add a document from the home"
    },
    "records": {
      "title": "Service history",
      "hint": "Choose up to {{max}} past services that help the technician.",
      "none": "No services recorded for this item."
    },
    "picker": {
      "title": "Documents of the home",
      "description": "Pick files to make available to the technician.",
      "none": "No other ready documents.",
      "add_one": "Add {{count}} document",
      "add_other": "Add {{count}} documents"
    },
    "preview": {
      "title": "What the technician will see",
      "technicianSees": "This is exactly what the technician receives with your current choices.",
      "loading": "Preparing the preview…",
      "expiry": "Each technician link has its own validity and you can revoke it at any time."
    },
    "snapshot": {
      "title": "Shared information",
      "problem": "Problem",
      "symptoms": "What is happening",
      "item": "Item",
      "noItem": "No item details were shared.",
      "where": "Location and availability",
      "noLocation": "Location not shared",
      "availability": "Availability",
      "history": "Service history",
      "documents": "Documents",
      "source": {
        "resident": "Recorded by the resident",
        "technician": "Informed by the provider"
      }
    }
  },
  "quotes": {
    "title": "Quotes",
    "intro": "Read the conditions of each quote before choosing. The price is only one of the differences.",
    "orderNote": "Quotes appear in the order they were received. Lumora does not rank them.",
    "backToRequest": "Back to the request",
    "empty": {
      "title": "No quotes yet",
      "description": "When technicians send quotes, they appear here to compare."
    },
    "details": "Each quote in detail",
    "type": {
      "fixed": "Fixed price",
      "estimate": "Estimate",
      "visit_required": "Visit required"
    },
    "state": {
      "current": "Current",
      "needs_reconfirmation": "Needs reconfirmation",
      "expired": "Expired",
      "withdrawn": "Withdrawn",
      "selected": "Selected",
      "not_selected": "Not selected"
    },
    "why": {
      "needs_reconfirmation": "This quote is based on an older version of the request. The technician needs to reconfirm it before you can choose it.",
      "expired": "This quote expired, so it cannot be chosen.",
      "withdrawn": "The technician withdrew this quote.",
      "selected": "This quote was selected.",
      "not_selected": "Another quote was selected.",
      "request_draft": "The request is a draft, so quotes cannot be chosen yet.",
      "request_selected": "A quote was already selected for this request.",
      "request_completed": "This request is completed.",
      "request_cancelled": "This request was cancelled."
    },
    "version": "Version {{number}}",
    "basedOn": "based on request version {{number}}",
    "sentAt": "received {{date}}",
    "price": "Price",
    "total": {
      "tbd": "Amount to be defined",
      "afterVisit": "Amount to be defined after the visit.",
      "knownSubtotal": "Known subtotal"
    },
    "scope": "Scope",
    "exclusions": "What is not included",
    "exclusionsNone": "No exclusions informed",
    "notInformed": "Not informed",
    "warranty": "Warranty (declared by the technician)",
    "availability": "Availability",
    "validUntil": "Valid until",
    "declaredNote": "Warranty, availability and validity are declared by the technician.",
    "visitFee": {
      "label": "Visit fee",
      "none": "No visit fee",
      "unknown": "Visit fee not informed"
    },
    "lines": {
      "title": "Items",
      "tbd": "to be defined",
      "category": {
        "labor": "Labor",
        "parts": "Parts",
        "other": "Other"
      }
    },
    "versions": {
      "title_one": "Version history ({{count}} version)",
      "title_other": "Version history ({{count}} versions)",
      "none": "No earlier versions."
    },
    "compare": {
      "title": "Comparison",
      "note": "All amounts are in {{currency}}. Differences in scope and exclusions matter as much as price.",
      "caption": "Comparison of quotes in {{currency}}",
      "criterion": "Criterion",
      "versionAndRevision": "Version {{version}}, based on request version {{revision}}",
      "criteria": {
        "type": "Type",
        "price": "Price",
        "basedOn": "Version",
        "state": "Status"
      }
    },
    "select": {
      "action": "Choose the quote from {{name}}",
      "visitAction": "Request a visit from {{name}}",
      "readFirst": "Read the scope, exclusions and costs above before choosing.",
      "title": "Choose the quote from {{name}}?",
      "description": "You are choosing this quote. The other quotes are marked as not selected, without showing them to each other.",
      "visitTitle": "Request a visit from {{name}}?",
      "visitDescription": "You are asking this technician to visit and evaluate. The price is not final and not accepted.",
      "acknowledge": "I understand that final terms and the work are agreed directly with the provider. This is not a contract and not a payment.",
      "confirm": "Choose this quote",
      "visitConfirm": "Request the visit",
      "done": "Choice recorded."
    }
  },
  "tech": {
    "footer": "This page is private and was shared with you for a quote. Lumora does not perform repairs or guarantee providers.",
    "requestFrom": "Request from {{name}}",
    "request": "Request for a quote",
    "revision": "Version {{number}}",
    "sharedOn": "Shared {{date}}",
    "expiresOn": "Link valid until {{date}}",
    "sharedNote": "You see only what the resident chose to share.",
    "gate": {
      "title": "Confirm your e-mail",
      "body": "This request is linked to a verified identity. Confirm your e-mail to open it."
    },
    "invalid": {
      "title": "Link not found",
      "body": "Check that you copied the whole link, or ask the resident for a new one."
    },
    "gone": {
      "invitation_revoked": {
        "title": "Access ended",
        "body": "The resident ended your access to this request. If you think this is a mistake, ask for a new link."
      },
      "invitation_expired": {
        "title": "This link expired",
        "body": "Ask the resident for a new link if you still want to send a quote."
      },
      "request_cancelled": {
        "title": "Request cancelled",
        "body": "The resident cancelled this request. Nothing else is needed from you."
      }
    },
    "respond": {
      "title": "Send a quote",
      "body": "To send or change a quote, confirm your e-mail with a one-time code.",
      "verify": "Confirm my e-mail"
    },
    "verify": {
      "why": "We send a 6-digit code to your e-mail to confirm it is you. No account is needed.",
      "hintRestricted": "{{hint}}",
      "email": "Your e-mail",
      "sendCode": "Send code",
      "sent": "We sent a 6-digit code to {{email}}. It is valid for 10 minutes.",
      "resent": "A new code was sent.",
      "code": "Code",
      "codeHint": "Six digits.",
      "codeFormat": "Enter the 6 digits.",
      "name": "Your name",
      "company": "Company",
      "confirm": "Confirm",
      "resend": "Send the code again",
      "resendIn": "Send again in {{seconds}} s",
      "waitToRetry": "Wait {{seconds}} s to try again.",
      "changeEmail": "Use another e-mail"
    },
    "quote": {
      "title": "Your quote",
      "formTitle": "Quote form",
      "reconfirmTitle": "Reconfirm your quote",
      "send": "Send quote",
      "sendNewVersion": "Send new version",
      "reconfirm": "Reconfirm quote",
      "reconfirmStart": "Review and reconfirm",
      "sendAgain": "Send a new quote",
      "newVersion": "Edit and send a new version",
      "sent": "Quote sent.",
      "notOpen": "This request is no longer open for quotes.",
      "withdraw": "Withdraw quote",
      "withdrawTitle": "Withdraw your quote?",
      "withdrawDescription": "The resident will no longer be able to choose it. You can send a new version later if the request is still open.",
      "withdrawnNote": "You withdrew this quote. Sending a new version makes it available again.",
      "needsReconfirmTitle": "The request information changed",
      "needsReconfirmBody": "Your quote is based on an older version. Review the information above (version {{number}}) and reconfirm it.",
      "outdatedTitle": "The request information changed",
      "outdatedBody": "Review the updated information above, adjust your quote if needed and send it again. Your answers are still here.",
      "currencyNote": "All amounts are in {{currency}}, the currency of the request.",
      "type": "Type of quote",
      "typeHint": {
        "fixed": "A closed price for the scope described.",
        "estimate": "An approximate price that may change. Mark items you cannot price yet.",
        "visit_required": "You need to visit before pricing."
      },
      "scopeHint": "What you will do, in plain words.",
      "exclusionsHint": "What is not included, so there are no surprises.",
      "lines": {
        "empty": "No items yet.",
        "item": "Item {{number}}",
        "category": "Category",
        "description": "Description",
        "quantity": "Quantity",
        "quantityInvalid": "Use a whole number of 1 or more.",
        "price": "Unit price ({{currency}})",
        "unknown": "Price to be defined",
        "lineTotal": "Item total",
        "add": "Add item",
        "remove": "Remove item {{number}}",
        "removeShort": "Remove",
        "max": "You reached the limit of {{max}} items.",
        "needOne": "Add at least one item, or choose “Visit required”.",
        "fix": "Fix the items marked below."
      },
      "fixedUnknown": "A fixed price should not have items to be defined. Consider choosing “Estimate”.",
      "preview": "Preview of the total",
      "previewUnknown": "At least one item has no price yet, so the total stays to be defined.",
      "previewNote": "Shown to help you. Lumora calculates the final values when you send.",
      "fee": {
        "none": "No visit fee",
        "known": "There is a visit fee",
        "unknown": "There is a visit fee, but I cannot say the amount yet",
        "amount": "Visit fee amount ({{currency}})",
        "unknownNote": "The resident will see that the fee exists but was not informed."
      },
      "warrantyHint": "Describe the warranty you offer, if any.",
      "notContract": "Sending a quote is not a contract. Final terms are agreed directly with the resident."
    },
    "outcome": {
      "quote_selected": {
        "title": "Your quote was selected",
        "body": "The resident will agree on final terms with you directly. This is not a contract or a payment."
      },
      "visit_requested": {
        "title": "The resident asked for your visit",
        "body": "This is a request for an evaluation visit, not an acceptance of a final price."
      },
      "not_selected": {
        "title": "Not selected this time",
        "body": "The resident chose another option. Thank you for answering."
      }
    },
    "service": {
      "title": "Register the service done",
      "correctTitle": "Correct the service record",
      "intro": "Your quote was chosen. When the work is done, register it here for the resident to confirm.",
      "list": "Your service records",
      "date": "Date of the service",
      "description": "What was done",
      "descriptionHint": "Describe the work in plain terms.",
      "parts": "Parts used",
      "cost": "Amount charged",
      "warrantyUntil": "Warranty until",
      "warrantyNotes": "Warranty conditions",
      "notice": "The resident will review and confirm. Until then, the record stays as “waiting for confirmation”.",
      "send": "Send for confirmation",
      "resend": "Resend corrected",
      "sent": "Sent for the resident’s confirmation.",
      "pendingNote": "The resident has yet to confirm this record.",
      "confirmedNote": "The resident confirmed this record.",
      "correctionAsked": "The resident asked for a correction.",
      "reason": "Reason: {{reason}}",
      "correct": "Correct record",
      "stale": "This record already changed. Reload the page to see the current version.",
      "status": {
        "pending_confirmation": "Waiting for confirmation",
        "correction_requested": "Correction requested",
        "confirmed": "Confirmed by the resident"
      }
    }
  },
  "notifications": {
    "title": "Notifications",
    "bell": "Notifications",
    "bellUnread_one": "Notifications, {{count}} unread",
    "bellUnread_other": "Notifications, {{count}} unread",
    "unreadCount_one": "{{formatted}} unread",
    "unreadCount_other": "{{formatted}} unread",
    "allRead": "All caught up.",
    "markAll": "Mark all as read",
    "onlyUnread": "Show only unread",
    "unread": "Unread",
    "markReadHint": "Open to mark as read.",
    "empty": {
      "title": "No notifications yet",
      "description": "Notices about quotes, services and reminders show up here."
    },
    "emptyUnread": {
      "title": "Nothing to read",
      "description": "You are up to date."
    },
    "fallback": {
      "someone": "Someone"
    },
    "prefs": {
      "title": "Notifications",
      "description": "For each type of notice, choose whether you want it in the app and by e-mail.",
      "inApp": "In the app",
      "email": "By e-mail",
      "types": {
        "quote_received": "Quote received",
        "quote_updated": "Quote updated",
        "request_selected_confirmation": "Quote choice",
        "request_cancelled": "Request cancelled",
        "service_confirmation_needed": "Service waiting for confirmation",
        "service_record_corrected": "Service corrected by the provider",
        "reminder_due": "Reminder due",
        "warranty_expiring": "Warranty ending soon",
        "export_ready": "Export ready",
        "ownership_transfer_requested": "Ownership transfer request",
        "member_joined": "New member",
        "extraction_budget_warning": "Document reading limit"
      }
    },
    "types": {
      "unknown": {
        "title": "News in the home",
        "body": "Open to see."
      },
      "quote_received": {
        "title": "Quote received",
        "body": "{{technician}} sent a quote for “{{request_title}}”."
      },
      "quote_updated": {
        "title": "Quote updated",
        "body": "{{technician}} updated the quote for “{{request_title}}”."
      },
      "request_selected_confirmation": {
        "title": "Choice recorded",
        "body_quote_selected": "{{selected_by}} chose a quote on “{{request_title}}”.",
        "body_visit_requested": "{{selected_by}} asked for a visit on “{{request_title}}”."
      },
      "request_cancelled": {
        "title": "Request cancelled",
        "body": "{{cancelled_by}} cancelled the request “{{request_title}}”."
      },
      "service_confirmation_needed": {
        "title": "Service waiting for confirmation",
        "body": "{{provider}} reported the service for “{{request_title}}”. Confirm it or ask for a correction."
      },
      "service_record_corrected": {
        "title": "Service corrected",
        "body": "{{provider}} corrected the service for “{{request_title}}”. Please review it again."
      },
      "reminder_due": {
        "title": "Reminder",
        "body": "“{{title}}” is due on {{due_on}}."
      },
      "warranty_expiring": {
        "title": "Warranty ending soon",
        "body": "The warranty of {{asset_name}} you declared ends on {{warranty_until}}."
      },
      "export_ready": {
        "title": "Export ready",
        "body": "The export of {{household_name}} is ready to download for 24 hours."
      },
      "ownership_transfer_requested": {
        "title": "Ownership transfer request",
        "body": "{{from}} wants to transfer ownership of {{household_name}} to you."
      },
      "member_joined": {
        "title": "New member",
        "body": "{{member}} joined {{household_name}}."
      },
      "extraction_budget_warning": {
        "title": "Document reading near the limit",
        "body": "{{household_name}} used {{used}} of {{limit}} readings this month."
      }
    },
    "filterAll": "All",
    "filterUnread": "Unread"
  },
  "reminders": {
    "title": "Reminders",
    "subtitle": "Dates you want to remember. Nothing completes by itself: you mark it as done.",
    "new": "New reminder",
    "state": {
      "upcoming": "Upcoming",
      "due_today": "Due today",
      "overdue": "Overdue",
      "finished": "Finished"
    },
    "source": {
      "warranty": "Warranty"
    },
    "warrantyReason": "Automatic notice before the warranty end you declared.",
    "recurrence": {
      "once": "Once",
      "days_one": "Every {{count}} day",
      "days_other": "Every {{count}} days",
      "months_one": "Every {{count}} month",
      "months_other": "Every {{count}} months"
    },
    "when": {
      "today": "today",
      "in_one": "in {{count}} day",
      "in_other": "in {{count}} days",
      "late_one": "{{count}} day late",
      "late_other": "{{count}} days late"
    },
    "finishedOn": "Finished on {{date}}",
    "lastDone": "Last done on {{date}}",
    "count_one": "{{formatted}} reminder",
    "count_other": "{{formatted}} reminders",
    "filters": {
      "status": "Status",
      "statuses": {
        "active": "Active",
        "overdue": "Overdue",
        "upcoming": "Upcoming",
        "finished": "Finished"
      },
      "asset": "Equipment or area",
      "assetAll": "All items",
      "assetSelected": "Selected item"
    },
    "empty": {
      "title": "No reminders yet",
      "description": "Create a reminder for a filter change, a check-up or any date that matters. You choose the frequency."
    },
    "noResults": {
      "title": "No reminders with these filters",
      "description": "Try another status or item.",
      "clear": "Clear filters"
    },
    "complete": {
      "action": "Mark as done",
      "title": "Mark “{{title}}” as done",
      "description": "Say when it was done. This is recorded.",
      "date": "Date it was done",
      "note": "Note",
      "confirm": "Mark as done",
      "nextOnce": "This reminder is one-time: once marked, it is finished.",
      "nextInterval": "The next date will be {{date}}, counted from {{from}}.",
      "nextIntervalUnknown": "The next date is calculated from the date you give.",
      "done": "Reminder marked as done.",
      "conflict": "This reminder changed or was already finished. Close this and check the updated list."
    },
    "form": {
      "editCrumb": "Edit",
      "editTitle": "Edit reminder",
      "titleLabel": "What to remember?",
      "titleHint": "For example “Change the purifier filter”.",
      "asset": "Equipment or area",
      "noAsset": "No item",
      "firstDate": "First date",
      "nextDate": "Next date",
      "dateHint": "Day in the home’s calendar. Today is {{today}}.",
      "repeat": "Repeat?",
      "once": "Just once",
      "interval": "Repeat at an interval I choose",
      "chooseRepeat": "Choose an option.",
      "every": "Every how many?",
      "everyInvalid": "Use a whole number from 1 to 120.",
      "unit": "Unit",
      "unitChoose": "Choose the unit",
      "units": {
        "days": "days",
        "months": "months"
      },
      "intervalNote": "After you mark it as done, the next date counts from the day it was done.",
      "notes": "Notes",
      "create": "Create reminder",
      "saved": "Reminder saved.",
      "conflict": "Someone else changed this reminder. Reload the page and try again.",
      "warrantyManaged": "This warranty reminder is kept from the equipment. To change it, edit the item’s warranty.",
      "openAsset": "Edit the equipment"
    },
    "delete": {
      "title": "Delete reminder",
      "description": "The reminder stops notifying. The item’s service history does not change.",
      "action": "Delete reminder",
      "confirmTitle": "Delete “{{title}}”?",
      "confirm": "This cannot be undone.",
      "done": "Reminder deleted."
    }
  }
}
